module.exports = __webpack_public_path__ + "img/sprinkle-17.bc411b64.webp";